import React from 'react';
import { connect } from 'react-redux';
import { length } from 'redux-form-validators';
import { toPlainObject, isEmpty } from 'lodash';

import { STATIC_ROOT } from '../../../../constants';
import { EMAIL_ALREADY_USED_STATUS_CODE } from '../../../../services/enrollment/constants';

import {
    sendProfileUpdateRequest,
    reset,
    setTimeoutId
} from '../../../../services/account/myprofile/actions';

import {
    CheckboxInputFieldComponent,
    EmailInputFieldComponent,
    FormComponent,
    LegendFieldComponent,
    TextInputFieldComponent
} from '../../../../components/form';
import SvgComponent from '../../../SvgComponent';
import SuccessMessageComponent from '../../../successmessage/SuccessMessageComponent';

import './ProfileFormComponent.scss';

const FORM_NAME = 'profile-form';

class ProfileFormComponent extends React.Component {
    componentWillUnmount() {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
    }

    submit = formData => {
        const { sendProfileUpdateRequest, timeoutId } = this.props;

        clearTimeout(timeoutId);

        sendProfileUpdateRequest(formData);
    };

    handleCloseMessage = () => {
        const { reset, timeoutId } = this.props;
        clearTimeout(timeoutId);
        reset();
    };

    render() {
        const {
            i18n,
            i18nForm,
            isAuthed,
            initialValues,
            requestSubmit,
            errorSubmit,
            errorMessage,
            statusCode,
            successProfilSubmit
        } = this.props;

        return (
            <React.Fragment>
                <FormComponent
                    form={FORM_NAME}
                    initialValues={isAuthed ? initialValues : {}}
                    classNameInputContainer="grid-3 has-gutter"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.BUTTON_VALIDATE}>
                    <TextInputFieldComponent
                        name="lastname"
                        label={i18nForm.LABEL_LASTNAME}
                        placeholder={i18nForm.LABEL_LASTNAME}
                        classNameInputContainer="one-third"
                        validate={[length({ max: 20, msg: i18nForm.LASTNAME_SIZE_ERROR })]}
                        readOnly
                    />
                    <TextInputFieldComponent
                        name="firstname"
                        label={i18nForm.LABEL_FIRSTNAME}
                        placeholder={i18nForm.LABEL_FIRSTNAME}
                        classNameInputContainer="one-third"
                        validate={[length({ max: 20, msg: i18nForm.FIRSTNAME_SIZE_ERROR })]}
                        readOnly
                    />
                    <EmailInputFieldComponent
                        name="email"
                        label={i18n.LABEL_EMAIL}
                        classNameInputContainer="two-thirds mr50"
                        readOnly
                    />
                    <React.Fragment>
                        {errorSubmit && statusCode === EMAIL_ALREADY_USED_STATUS_CODE && (
                            <LegendFieldComponent classNameInputContainer="full color-err err-picto">
                                <div className="picto">
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-errors.svg`}
                                        width={20}
                                        height={20}
                                        aria-hidden="true"
                                    />
                                </div>
                                <div>{i18n.EMAIL_ALREADY_USED}</div>
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                    <LegendFieldComponent classNameInputContainer="full">
                        {i18n.UPDATABLE_ADDRESS_FIELD}
                    </LegendFieldComponent>
                    <CheckboxInputFieldComponent
                        name="newsletter"
                        classNameInputContainer="three-quarters mt30"
                        options={[{ label: i18n.TEXT_NEWSLETTER, value: 1 }]}
                    />
                    <React.Fragment>
                        {errorSubmit && statusCode !== EMAIL_ALREADY_USED_STATUS_CODE && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>

                <SuccessMessageComponent
                    visible={successProfilSubmit}
                    message={i18n.CONFIRM_UPDATE_PERSONAL_DATA}
                    onClose={this.handleCloseMessage}
                />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18nForm: state.i18n.feature.form,
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : '',
            newsletter: user.activeMailingOffer ? user.activeMailingOffer : false
        },
        requestSubmit: state.account.myprofile.fetching,
        errorSubmit: !isEmpty(state.account.myprofile.error),
        errorMessage: state.account.myprofile.error,
        statusCode: state.account.myprofile.status,
        successProfilSubmit: state.account.myprofile.successProfileUpdateRequestSubmit,
        timeoutId: state.account.myprofile.resetTimeoutId
    };
}

const mapDispatchtoProps = {
    sendProfileUpdateRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchtoProps)(ProfileFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfileFormComponent.js